import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SystemPageType } from '../ops-system-status.component';
import { CommIFStatus, FcuStatus, SystemStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';
import { FcuIDs } from '@helpers/ams-data-fram-constants';
import { SystemStatusRoutingService } from '@service/system-status-routing.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-ops-status-side-menu',
    templateUrl: './ops-status-side-menu.component.html',
    styleUrls: ['./ops-status-side-menu.component.scss'],
    standalone: false,
})
export class OpsStatusSideMenuComponent implements OnInit, OnDestroy {
    @Input() isReceivingData: boolean;
    @Input() systemStatusData: SystemStatus;
    @Input() selectedCommIF: CommIFStatus;
    @Input() selectedFcuSrc: string;
    @Input() selectedPage: SystemPageType;
    @Output() onPageSelected: EventEmitter<string> = new EventEmitter<string>();
    @Output() onSelectCommIf: EventEmitter<CommIFStatus> = new EventEmitter<CommIFStatus>();

    showFcuList: boolean = false;
    showCommsList: boolean = false;

    destroySubscriptions$: Subject<void> = new Subject();

    constructor(
        private systemStatusService: SystemStatusService,
        private systemStatusRoutingService: SystemStatusRoutingService,
    ) {}

    ngOnInit(): void {
        this.systemStatusRoutingService
            .selectedFuIndexSubject()
            .pipe(takeUntil(this.destroySubscriptions$))
            .subscribe(({ fcuSrc, fuIndex }) => {
                if (fcuSrc) {
                    this.showFcuList = true;
                    this.selectedFcuSrc = fcuSrc;
                }
            });

        this.systemStatusRoutingService
            .selectedFcuIndexSubject()
            .pipe(takeUntil(this.destroySubscriptions$))
            .subscribe((fcuSrc) => {
                if (fcuSrc) {
                    this.showFcuList = true;
                    this.selectedFcuSrc = fcuSrc;
                }
            });

        this.systemStatusRoutingService
            .openFcuListPageSubject()
            .pipe(takeUntil(this.destroySubscriptions$))
            .subscribe(() => {
                this.showFcuList = true;
                this.selectedFcuSrc = null;
            });
    }

    ngOnDestroy(): void {
        this.destroySubscriptions$.next();
        this.destroySubscriptions$.complete();
    }

    displaySelectedPage(page) {
        if (page !== SystemPageType.Fcu) {
            this.showFcuList = false;
        }
        if (page !== SystemPageType.Comms) {
            this.showCommsList = false;
        }
        this.selectedCommIF = null;
        this.selectedFcuSrc = null;
        this.selectedPage = page;
        this.onSelectCommIf.emit(null);
        this.onPageSelected.emit(page);
    }

    getAlarmCounts(systemObject) {
        if (!this.isReceivingData) return 0;
        return this.systemStatusService.getAlarmCounts(systemObject);
    }

    selectCommIF(commIF) {
        this.selectedCommIF = commIF;
        this.onSelectCommIf.emit(commIF);
    }

    selectFcu(fcu) {
        this.systemStatusRoutingService.openSelectedFcu(fcu.key);
        this.selectedFcuSrc = fcu.key;
    }

    getFcuIndex(fcuSrc) {
        return FcuIDs[fcuSrc];
    }
}
